import { render, staticRenderFns } from "./ScreenPayIntro.vue?vue&type=template&id=54571b6c&scoped=true"
import script from "./ScreenPayIntro.vue?vue&type=script&lang=ts"
export * from "./ScreenPayIntro.vue?vue&type=script&lang=ts"
import style0 from "./ScreenPayIntro.vue?vue&type=style&index=0&id=54571b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54571b6c",
  null
  
)

export default component.exports